<template>
  <div class="monthly-charge-log-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-data"></i> Monthly Visualization Report</span>
      </div>

      <div>
        <div class="search-area">

          <el-date-picker v-model="dateSearch" type="daterange" range-separator="To" start-placeholder="Start date"
            end-placeholder="End date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
          <el-button slot="append" type="primary" icon="el-icon-search" @click="getLogs()">Search</el-button>
          <el-button icon="el-icon-download" type="success" @click="exportExcel()">Export</el-button>
        </div>


        <data-tables v-loading="loading" :data="tableData" border :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="createdDateFormat" label="Create Date" header-align="center" align="center"
            width="150"> </el-table-column>

          <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center" width="120">
          </el-table-column>
          <el-table-column prop="monthlyUid" label="Monthly UID" header-align="center" align="center" width="180">
          </el-table-column>
          <el-table-column prop="taskType" label="Task Type" header-align="center" align="center" width="180">
          </el-table-column>
          <el-table-column prop="messageLog" label="Message Log" header-align="center" align="center">
          </el-table-column>

        </data-tables>

      </div>


    </el-card>
  </div>
</template>

<script>
import { getMonthlychargeLogs, getMonthlychargeLogsExcel } from "@/api/report";
import { currentDateTime } from '@/utils'
export default {

  data() {
    return {
      dateSearch: "",
      tableData: [],
      loading: false,
      query: {

        datefrom: "",
        dateto: "",
      },
    }
  },
  methods: {
    getLogs(){
      this.loading = true
      this.getQuery();
      getMonthlychargeLogs(this.query).then(({result, data})=>{
        this.loading = false
        if(result){
          this.tableData = data
        }
      })
    },
    getQuery(){
      this.query.datefrom = this.dateSearch[0] ||
          currentDateTime("YYYY-MM-DD");
        this.query.dateto =
          this.dateSearch[1] ||
          currentDateTime("YYYY-MM-DD");
      return this.query;
    },
    exportExcel(){
      getMonthlychargeLogsExcel(this.getQuery())
    }

  },
  created() {
    this.getLogs()

  }
}
</script>

<style lang="scss">
.monthly-charge-log-report {
  .search-area {
    margin-bottom: 16px;

    button {
      margin-left: 10px;
      margin-bottom: 16px;
    }

    .el-date-editor {
      margin-bottom: 16px;
    }

    .el-radio-group {
      margin-top: 12px;
      margin-right: 10px;
      margin-bottom: 16px;
    }
  }
}
</style>